import { render, staticRenderFns } from "./MainAuth.vue?vue&type=template&id=11002f45&"
import script from "./MainAuth.vue?vue&type=script&lang=js&"
export * from "./MainAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports